const HttpBackend = require('i18next-http-backend/cjs');
const Sentry = require('@sentry/nextjs');

/**
 * @type {import('next-i18next').UserConfig}
 */
module.exports = {
  i18n: {
    localeDetection: false,
    defaultLocale: 'default',
    locales: ['default', 'en', 'de', 'fr', 'it', 'da', 'fi', 'nl', 'ru', 'sv', 'tr'],
  },
  compatibilityJSON: 'v4',
  localePath:
    typeof window === "undefined"
      ? require("path").resolve("./public/locales")
      : "/locales",
  reloadOnPrerender: process.env.NODE_ENV === 'development',
  fallbackLng: 'en',
  defaultNS: 'common',
  returnEmptyString: false,
  nonExplicitSupportedLngs: true,
  saveMissing: true,

  parseMissingKeyHandler: (key) => {
    console.warn(`Missing translation key: ${key}`);
    return '';
  },

  missingKeyHandler: (lng, ns, key, fallbackValue) => {
    if (process.env.BUILD_ENV === 'production') return;

    console.warn(
      `Missing translation key: ${key} in namespace: ${ns}, using fallbackValue: ${fallbackValue}`,
    );

    if (process.env.BUILD_ENV === 'staging') {
      Sentry.captureMessage(`Missing translation key: ${key} in namespace: ${ns}`, {
        extra: { fallbackValue, lng, ns, key },
        level: 'warning',
      });
    }
  },

  // Only in dev, where HttpBackend is registered below
  ...(typeof window !== 'undefined'
    ? { backend: { loadPath: '/locales/{{lng}}/{{ns}}.json' } }
    : {}),

  serializeConfig: false,

  use:
    process.env.NODE_ENV !== 'production' && typeof window !== 'undefined'
      ? [HttpBackend]
      : [],
};